import {useTranslation} from 'react-i18next'

export const useFormInputLabelWithSuffix = ({
  label,
  optional,
  optionalTKey = 'form.label.optional'
}: {
  label: string
  optional?: boolean
  optionalTKey?: string
}) => {
  const {t} = useTranslation()

  let suffix = ''
  if (optional) suffix = ` (${t(optionalTKey)})`

  return label + suffix
}
